import React from "react";
import Master from "../Layout/Master";

const Tokenization = () => {
  return (
    <div>
      <Master />
      <div className="container">
        <div className="row">
          <div className="col-lg-4 offset-4 text-white mt-5">
            <h1>Coming Soon!</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tokenization;
